import Vue from 'vue';

const state = {
  proxyHolder: {},
  proxyDropdownSelection: '',
  proxyAbstainOption: ''
};

const getters = {
  proxyHolder: state => state.proxyHolder,
  proxyDropdownSelection: state => state.proxyDropdownSelection,
  proxyAbstainOption: state => state.proxyAbstainOption
};

const actions = {
  setProxyHolder({commit}, proxyHolder) {
    return commit('SET_PROXY_HOLDER', proxyHolder);
  },
  setOtherProxyHolder({commit}, otherProxyHolder) {
    return commit('SET_OTHER_PROXY_HOLDER', otherProxyHolder);
  },
  clearProxyHolder({commit}) {
    return commit('SET_PROXY_HOLDER', {});
  },
  setProxyDropdownSelection({commit}, dropdownSelection) {
    return commit('SET_PROXY_DROPDOWN_SELECTION', dropdownSelection);
  },
  setProxyAbstainOption({commit}, proxyAbstainOption) {
    return commit('SET_PROXY_ABSTAIN_OPTION', proxyAbstainOption);
  },
  clearProxyAbstainOption({commit}) {
    return commit('SET_PROXY_ABSTAIN_OPTION', '');
  }
};

const mutations = {
  SET_PROXY_HOLDER(state, proxyHolder) {
    state.proxyHolder = proxyHolder;
  },
  SET_OTHER_PROXY_HOLDER(state, otherProxyHolder) {
    Vue.set(state.proxyHolder, 'name', otherProxyHolder);
  },
  SET_PROXY_DROPDOWN_SELECTION(state, dropdownSelection) {
    state.proxyDropdownSelection = dropdownSelection;
  },
  SET_PROXY_ABSTAIN_OPTION(state, proxyAbstainOption) {
    state.proxyAbstainOption = proxyAbstainOption;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
